import React from 'react'
import { useStore } from '../../../store/store';
import { Form, InputNumber } from 'antd';
import { pageHeight, unitName } from '../../../constants/gridConfig';
import { maxHeaderFooterHeight } from '../../../constants/constants';
import './DocumentTab.less'

export const DocumentTab = () => {
  const setConfiguration = useStore(({ setConfiguration }) => setConfiguration)
  const configuration = useStore(({ configuration }) => configuration)
  const landscape = useStore(({ landscape }) => landscape)

  return (
    <>
      {!landscape && <>
        <Form.Item
          name='dmz'
          label="Zone de saut de page des titres"
          extra={
            <span className='document-tab-hint'>
              <span className='document-tab-dmz-swatch' />
              Un titre qui arrive dans cette zone, en bas de page, passe à la page suivante pour rester avec son contenu.
            </span>
          }
        >
          <InputNumber
            min={0}
            max={pageHeight - maxHeaderFooterHeight * 2 - 100}
            addonAfter={unitName}
            style={{ width: 150 }}
            defaultValue={configuration.dmz}
            onChange={(value) => {
              setConfiguration({
                ...configuration,
                dmz: value
              });
            }}
          />
        </Form.Item>
      </>}
    </>
  );
};
